export default {
    PersonaHeaderShown: { datapoint: { name: 'PersonaHeaderShown' } },
    PersonaHeaderFREShown: { datapoint: { name: 'PersonaHeaderFREShown' } },
};
